import React from "react";
import { SwitchStyled, SwitchWrapper } from "./styles";
export const Switch = ({
  label,
  ...props
}) => label ? /*#__PURE__*/React.createElement(SwitchWrapper, null, /*#__PURE__*/React.createElement(SwitchStyled, props), label) : /*#__PURE__*/React.createElement(SwitchStyled, props);
Switch.displayName = "Switch";